// src/Routes.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';

// import Home from './components/Home';
// import Contact from './components/Contact';
import Login from './components/Login';
import Logout from './components/Logout';
import ChartReasonForVisit from './components/chart/ReasonForVisit';
import Summary from './components/chart/Summary';
import WaitingRoom from './components/chart/WaitingRoom';
import Profile from './components/Profile';
import AllUsers from './components/AllUsers';

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="" element={<Home />} /> */}
      {/* <Route path="/contact" element={<Contact />} /> */}
      <Route path="" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/waiting-room" element={<WaitingRoom />} />
      <Route path="/waiting-room/reason" element={<ChartReasonForVisit />} />
      <Route path="/waiting-room/reason/summary" element={<Summary />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/users" element={<AllUsers />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  );
};

export default AppRoutes;
